import { UseResizeDetectorReturn } from "react-resize-detector";
import { useResizeDetector } from "react-resize-detector";

export const usePaneSizes = (): {
  mainPane: UseResizeDetectorReturn<HTMLDivElement>;
  supportingPane: UseResizeDetectorReturn<HTMLDivElement>;
} => {
  const mainPane = useResizeDetector<HTMLDivElement>();
  const supportingPane = useResizeDetector<HTMLDivElement>();

  return { mainPane: mainPane, supportingPane: supportingPane };
};
